<div class="main-div">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>Bem vindo(a)</mat-card-title>
      <mat-card-subtitle class="card-subtitle">Clique no botÃ£o a seguir para acessar as disciplinas</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions class="card-button">
      <button mat-raised-button color="primary" (click)="acessoMoodle()">Acesse suas disciplinas</button>
    </mat-card-actions>
  </mat-card>
</div>

<app-notice-board></app-notice-board>

